module.exports = __webpack_public_path__ + "static/media/ThreatLocker_logo wordmark_color_PNG 1200.3e7d7a4f.png";